export default __webpack_public_path__ + "static/media/singleQuote.ef54f575.svg";